import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { KwikUISafeHtmlPipeModule } from "./safe-html/safe-html.module";
import { KwikUISafeUrlPipeModule } from "./safe-url/safe-url.module";
import { KwikUISearchFilterPipeModule } from "./search-filter/search-filter.module";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    KwikUISafeHtmlPipeModule,
    KwikUISafeUrlPipeModule,
    KwikUISearchFilterPipeModule
  ],
  exports: [
    KwikUISafeHtmlPipeModule,
    KwikUISafeUrlPipeModule,
    KwikUISearchFilterPipeModule
  ]
})
export class KwikUIPipeModule {}
